import useElScrollToBottom from './useElScrollToBottom';

module.exports = {
  useElScrollToBottom,
}